import { useQuery } from '@tanstack/react-query';
import { attemptGetLiveConnectionStats } from 'api/OrgApi';

export const useGetLiveConnectionStats = (payload) => {
  return useQuery({
    queryKey: ['liveConnectionStats', payload],
    queryFn: () => attemptGetLiveConnectionStats(payload),
    enabled: !!payload, // Ensure the query only runs if payload is not null
  });
};